import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class BusinessGoalsGoalSubgoalsController extends Controller {
  @tracked goalWizardIsOpen = false;

  @action
  toggleGoalWizard() {
    this.goalWizardIsOpen = !this.goalWizardIsOpen;
  }
}
